<!--
Author: TangChen
Date: 2019-01-03
Desc: 购买定投基金，由index.js 配置引入
-->
<template>
    <div class="comp-plan-buy comp">
        <div v-if="showTabs" class="flex fs18 lin18 mt12">
            <div
                :class="[selectedTab === '1' ? 'bc_E60012 c_ffffff' : '']"
                class="pointer bor_E4E4E4 bor_b_0 br-t-12 c_333 pt14 pb14 pl44 pr44"
                v-on:click="clickTab('1')"
            >
                普通定投
            </div>
            <div
                v-if="
                    $cache.getCompanyInfoParam('10301003') &&
                    $cache.getCompanyInfoParam('10301003').indexOf('A86') > -1
                "
                :class="[selectedTab === '7' ? 'bc_E60012 c_ffffff' : '']"
                class="pointer bor_E4E4E4 bor_b_0 br-t-12 c_333 pt14 pb14 pl44 pr44"
                v-on:click="clickTab('7')"
            >
                目标盈定投
            </div>
            <div
                v-if="
                    $cache.getCompanyInfoParam('10301003') &&
                    $cache.getCompanyInfoParam('10301003').indexOf('A19') > -1
                "
                :class="[selectedTab === '4' ? 'bc_E60012 c_ffffff' : '']"
                class="pointer bor_E4E4E4 bor_b_0 br-t-12 c_333 pt14 pb14 pl44 pr44"
                v-on:click="clickTab('4')"
            >
                智能定投
            </div>
        </div>
        <div class="bor_E4E4E4">
            <el-form
                v-show="!buySuccess"
                ref="fundInfo"
                :model="fundInfo"
                :rules="rules"
                label-width="350px"
                class="pwdForm"
                inline-message
                v-on:submit.native.prevent
            >
                <el-form-item
                    v-if="$route.query.isCom && fund.subfundinfos && fund.subfundinfos.length"
                    label="基金组合及比例："
                >
                    <div class="flex">
                        <div class="mr50">
                            <div v-for="(item, index) in fund.subfundinfos" :key="index">
                                [{{ item.fundcode }}]{{ item.fundname }}
                            </div>
                        </div>
                        <div>
                            <div v-for="(item, index) in fund.subfundinfos" :key="index">
                                {{ item.ratio * 100 + "%" }}
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item v-else label="基金名称：" class="form-text">
                    <div v-cloak class="text-con">
                        {{ fund.fundname + "(" + fund.fundcode + ")" }}
                    </div>
                </el-form-item>
                <el-form-item
                    v-if="!$route.query.isCom"
                    label="定投计划名称："
                    prop="buyplanname"
                    class="form-text"
                >
                    <el-input
                        v-model.trim="fundInfo.buyplanname"
                        placeholder="请输入投资计划名称"
                        :maxlength="32"
                        :disabled="action === '2'"
                    />
                </el-form-item>
                <el-form-item
                    v-if="!$route.query.isCom"
                    label="资金来源："
                    prop="way"
                    class="form-text"
                >
                    <el-radio-group v-model="fundInfo.way" :disabled="action !== '0'">
                        <el-radio label="2" name="sell">银行卡</el-radio>
                        <!--<el-radio-->
                        <!--v-if="selectedTab !== '7'"-->
                        <!--label="1"-->
                        <!--name="sell"-->
                        <!--:disabled="-->
                        <!--Number(xjbAll) === 0 ||-->
                        <!--$util.fmtNum(xjbAll) === '&#45;&#45;' ||-->
                        <!--fund.fundcode === xjbFundInfo.fundcode-->
                        <!--"-->
                        <!--&gt;-->
                        <!--大成钱柜-->
                        <!--<span>-->
                        <!--(可用余额：-->
                        <!--<span class="red">{{ $util.fmtNum(xjbAll) }}</span>-->
                        <!--元)-->
                        <!--</span>-->
                        <!--</el-radio>-->
                    </el-radio-group>
                </el-form-item>
                <el-form-item
                    v-if="fundInfo.way == '2' && hasBankRroute"
                    label="扣款账号："
                    prop="selectedBankid_card"
                    class="payway-list"
                >
                    <div class="flex">
                        <div>
                            <el-select
                                v-model="selectedBankid_card"
                                placeholder="请选择支付方式"
                                :class="{
                                    hasVal: bankInfo && bankInfo.label && fundInfo.pay != ''
                                }"
                                :disabled="action !== '0'"
                            >
                                <el-option-group class="bank-sel">
                                    <el-option
                                        v-for="item in bankListsOfR"
                                        :key="item.bankid_card"
                                        :label="item.label"
                                        :value="item.bankid_card"
                                        class="el-option-group_wrap"
                                    >
                                        <div v-if="!item.bankAdd" class="bank-info">
                                            <img
                                                :src="$util.getImg(item.bankid_card.split('_')[0])"
                                                alt=""
                                            />
                                            <span>{{ $util.getDimCard(item.label) }}</span>
                                            <p v-if="!item.bankAdd">
                                                {{ item.text }}
                                            </p>
                                        </div>
                                        <div v-if="item.bankAdd" class="option-group clear">
                                            {{ item.bankCate }}
                                            <el-button
                                                type="blue"
                                                v-on:click.prevent="
                                                    $router.push({
                                                        name:
                                                            fundInfo.way === '3'
                                                                ? 'bank'
                                                                : 'addbank'
                                                    })
                                                "
                                            >
                                                {{ item.bankAdd }}
                                            </el-button>
                                        </div>
                                    </el-option>
                                </el-option-group>
                            </el-select>
                            <div v-if="bankInfo && bankInfo.label" class="el-select-img">
                                <img :src="$util.getImg(bankInfo.bankcode)" alt="" />
                                <span class="k-text-flow">
                                    {{
                                        $util.getDimCard(
                                            bankInfo.label.split("-").length === 1
                                                ? bankInfo.label
                                                : bankInfo.label.split("-")[1]
                                        )
                                    }}
                                </span>
                            </div>
                        </div>
                        <div
                            v-if="fundInfo.way == '2'"
                            class="c_007CEE fs14 ml10"
                            v-on:click="
                                $router.push({ name: 'addbank', query: { biztype: 'plan' } })
                            "
                        >
                            新增银行卡
                        </div>
                    </div>
                </el-form-item>
                <el-form-item v-else label="扣款账号：" prop="pay" class="payway-list">
                    <div class="flex">
                        <div :class="{ w400: fundInfo.way === '2' }">
                            <el-select
                                v-if="fundInfo.way !== '1' && bankLists.length > 0"
                                v-show="action === '0'"
                                v-model="fundInfo.pay"
                                placeholder="请选择支付方式"
                                :class="{
                                    hasVal: bankInfo && bankInfo.label,
                                    w400: fundInfo.way === '2'
                                }"
                                :disabled="action !== '0'"
                                v-on:change="bankSel"
                            >
                                <el-option-group
                                    v-for="(group, index) in bankLists"
                                    :key="index"
                                    :label="group.label"
                                    class="bank-sel"
                                >
                                    <el-option
                                        v-for="item in group.options"
                                        :key="item.bankcardid"
                                        :label="item.label"
                                        :value="item.bankcardid"
                                    >
                                        <div v-if="!item.bankAdd" class="bank-info flex between">
                                            <div>
                                                <img :src="$util.getImg(item.bankcode)" alt="" />
                                                <span>{{ item.label }}</span>
                                                <p v-if="!item.bankAdd">
                                                    {{ item.text }}
                                                </p>
                                                <div v-if="!$util.isEmpty(item.discountrate)">
                                                    {{ Number(item.discountrate) * 10 }}折
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="item.bankAdd" class="option-group clear">
                                            {{ item.bankCate }}
                                            <el-button
                                                type="blue"
                                                v-on:click.prevent="
                                                    $router.push({ name: 'addbank' })
                                                "
                                            >
                                                {{ item.bankAdd }}
                                            </el-button>
                                        </div>
                                    </el-option>
                                </el-option-group>
                            </el-select>
                            <div
                                v-if="fundInfo.way !== '1' && bankInfo && bankInfo.label"
                                class="el-select-img flex between pr25"
                            >
                                <div>
                                    <img :src="$util.getImg(bankInfo.bankcode)" alt="" />
                                    <span class="k-text-flow">{{ bankInfo.label }}</span>
                                </div>
                                <div v-if="!$util.isEmpty(bankInfo.discountrate)">
                                    {{ Number(bankInfo.discountrate) * 10 }}折
                                </div>
                            </div>
                            <el-radio-group
                                v-if="
                                    (fundInfo.way === '1' && xjbInfo.length === 0) ||
                                    (fundInfo.way === '2' && bankLists.length === 0)
                                "
                                class="bank-radio"
                            >
                                <el-radio label="no-selec" border>
                                    <div class="bank-img-sel">
                                        <div v-if="fundInfo.way === '1'" class="k-text-flow">
                                            您的现金宝还未充值，请立即
                                            <span
                                                class="like-a"
                                                v-on:click="
                                                    $router.push({ name: 'currencycharge' })
                                                "
                                            >
                                                前往充值
                                            </span>
                                        </div>
                                        <div v-else class="k-text-flow">
                                            您的还未添加银行卡，请立即
                                            <span
                                                class="like-a"
                                                v-on:click="
                                                    $router.push({
                                                        name: 'addbank',
                                                        query: { biztype: 'plan' }
                                                    })
                                                "
                                            >
                                                前往添加
                                            </span>
                                        </div>
                                    </div>
                                </el-radio>
                            </el-radio-group>
                            <el-radio-group
                                v-if="fundInfo.way === '1' && xjbInfo.length > 0"
                                v-model="fundInfo.pay"
                                class="bank-radio"
                                :disabled="action !== '0'"
                            >
                                <el-radio
                                    v-for="bank in xjbInfo"
                                    :key="bank.transid + bank.xjbfundcode"
                                    :label="bank.transid + bank.xjbfundcode"
                                    border
                                >
                                    <div class="bank-img-sel">
                                        <img :src="$util.getImg(bank.bankcode)" alt="" />
                                        <div class="k-text-flow">
                                            <span
                                                class="bank-name"
                                                :title="$cache.getDict('110080', bank.bankcode)"
                                            >
                                                {{
                                                    $cache
                                                        .getDict("110080", bank.bankcode)
                                                        .toString()
                                                        .substr(0, 6)
                                                }}
                                            </span>
                                            总额(元):
                                            <span class="bank-balance">
                                                {{ $util.fmtNum(bank.totalasset) }}
                                            </span>
                                        </div>
                                        <i class="el-icon-check" aria-hidden="true" />
                                    </div>
                                </el-radio>
                            </el-radio-group>
                        </div>
                        <div
                            v-if="fundInfo.way == '2'"
                            class="c_007CEE fs14 ml10"
                            v-on:click="
                                $router.push({ name: 'addbank', query: { biztype: 'plan' } })
                            "
                        >
                            新增银行卡
                        </div>
                    </div>
                </el-form-item>
                <el-form-item
                    v-if="!$route.query.isCom"
                    label="收费方式："
                    prop="way"
                    class="form-text"
                >
                    <el-select v-model="fundInfo.sharetype" :disabled="fund.sharetype !== 'A,B'">
                        <el-option value="A" label="前收费"></el-option>
                        <el-option value="B" label="后收费"></el-option>
                    </el-select>
                    <el-tooltip placement="top">
                        <div slot="content">
                            前端收费是在申购基金时收取申购费,
                            <br />
                            而后端收费则是在申购时不收费，
                            <br />
                            在赎回时才收取手续费用。
                        </div>
                        <img src="../../assets/img/tip.png" class="w18 h18 ml12" />
                    </el-tooltip>
                </el-form-item>
                <el-form-item label="定投周期：" prop="debitcycle" class="form-text">
                    <el-radio-group v-model="fundInfo.debitcycle" :disabled="action === '2'">
                        <el-radio
                            v-for="(item, index) in debitcycleArr"
                            v-show="!($route.query.isCom && item.subitem === '3')"
                            :key="index"
                            :label="item.subitem"
                            name="debitcycle"
                        >
                            {{ item.subitemname }}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <div v-if="fundInfo.debitcycle !== '3'">
                    <el-form-item
                        label="定投日期："
                        prop="debitdate"
                        :class="{
                            'form-text': fund.sign && !isPwdCheck && !(wisdom && action !== '0')
                        }"
                    >
                        <el-select
                            v-model="fundInfo.debitdate"
                            placeholder="请选择扣款日期"
                            :disabled="action === '2'"
                        >
                            <el-option
                                v-for="(item, index) in debitdateArr"
                                :key="index"
                                :label="item.subitemname"
                                :value="item.subitem"
                            />
                        </el-select>
                    </el-form-item>
                </div>
                <div v-if="selectedTab === '4'" class="bor_D9D9D9 ml240 mr240 mb24">
                    <el-tabs v-model="activeName">
                        <el-tab-pane label="标准智能定投" name="first"></el-tab-pane>
                        <el-tab-pane label="个性智能定投" name="second"></el-tab-pane>
                    </el-tabs>
                    <div class="tabForm">
                        <el-form-item label="指数类型：">
                            <el-select
                                v-model="fundInfo.indextype"
                                :disabled="activeName === 'first'"
                            >
                                <el-option
                                    v-for="(item, index) in $cache.getDict('130050')"
                                    :key="index"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                ></el-option>
                            </el-select>
                            <el-tooltip placement="top">
                                <div slot="content">
                                    参考指数则应选择与所投资基金相
                                    <br />
                                    关性较高的参数，可考虑基金业绩
                                    <br />
                                    比较基准中涉及的股票指数。
                                </div>
                                <img src="../../assets/img/tip.png" class="w18 h18 ml12" />
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item label="均线类型：">
                            <el-select
                                v-model="fundInfo.policyvalue"
                                :disabled="activeName === 'first'"
                            >
                                <el-option
                                    v-for="(item, index) in $cache.getDict('210312')"
                                    :key="index"
                                    :label="item.subitemname"
                                    :value="item.subitem"
                                ></el-option>
                            </el-select>
                            <el-tooltip placement="top">
                                <div slot="content">
                                    所取均线越大、收益越大、两者正相关。
                                    <br />
                                    在投资者实际操作中，运用周期较长的
                                    <br />
                                    均线(如750日以上均线，即3年以上均
                                    <br />
                                    线)的可行性较差，虽然运用他们可以
                                    <br />
                                    获得较高收益，但是总的定投金额少，
                                    <br />
                                    即意味着'智能定投'发生的概率小或者每
                                    <br />
                                    次'智能定投'的金额远远少于'普通定投'
                                    <br />
                                    ，对于投资者来讲，可投资的机会较小，
                                    <br />
                                    实际意义不大。所以我们建议用中均线，
                                    <br />
                                    即180、250或500日均线做为投资参考。
                                </div>
                                <img src="../../assets/img/tip.png" class="w18 h18 ml12" />
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item label="金额控制参数级差：">
                            <el-select
                                v-model="fundInfo.investscale"
                                :disabled="activeName === 'first'"
                            >
                                <el-option label="10%" value="0.1"></el-option>
                                <el-option label="20%" value="0.2"></el-option>
                                <el-option label="30%" value="0.3"></el-option>
                            </el-select>
                            <el-tooltip placement="top">
                                <div slot="content">
                                    根据实证分析，我们认为选取级差为基础金额
                                    <br />
                                    的10%-30%最有效，所得到的效果也最优。
                                </div>
                                <img src="../../assets/img/tip.png" class="w18 h18 ml12" />
                            </el-tooltip>
                        </el-form-item>
                        <el-form-item label="基础金额：" prop="amount">
                            <el-input
                                v-model.trim="fundInfo.amount"
                                class="prefix"
                                :placeholder="pla"
                                :maxlength="14"
                                prefix-icon="fa fa-jpy"
                                :disabled="action === '2'"
                            />
                        </el-form-item>
                        <el-form-item v-if="Number(fundInfo.amount)" label="金额确认：">
                            {{ $util.capitalRMB(fundInfo.amount) }}
                        </el-form-item>
                    </div>
                </div>
                <el-form-item v-if="selectedTab !== '4'" label="每期扣款金额：" prop="amount">
                    <el-input
                        v-model.trim="fundInfo.amount"
                        class="prefix"
                        :placeholder="pla"
                        :maxlength="14"
                        prefix-icon="fa fa-jpy"
                        :disabled="action === '2'"
                    />
                </el-form-item>
                <el-form-item
                    v-if="selectedTab !== '4' && Number(fundInfo.amount)"
                    label="确认金额："
                >
                    {{ $util.capitalRMB(fundInfo.amount) }}
                </el-form-item>
                <el-form-item v-show="feeGate.estimatedcost" label="预估手续费：" class="form-text">
                    <div class="text-con">
                        <span style="color: red">{{ feeH }}</span>
                        <span>元</span>
                    </div>
                </el-form-item>
                <el-form-item v-if="selectedTab == '7'" label="目标收益：" prop="debitcycle">
                    <div class="flex hcenter fs16 lin16">
                        <el-radio-group v-model="selectedTargetrate">
                            <el-radio label="0.05">5%</el-radio>
                            <el-radio label="0.08">8%</el-radio>
                            <el-radio label="0.10">10%</el-radio>
                            <el-radio label="">自选</el-radio>
                        </el-radio-group>
                        <div
                            v-show="selectedTargetrate === ''"
                            class="flex hcenter bor_D9D9D9 pt12 pb12 pl18 pr13 ml8"
                        >
                            <input
                                id="par3Id"
                                v-model="inputTargetrate"
                                type="text"
                                class="w36 bor_none c_999 outline_none"
                            />
                            <span>%</span>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item
                    v-if="selectedTab == '7'"
                    label="止盈后自动赎回到："
                    prop="sellTo"
                    class="payway-list"
                >
                    <div class="flex lin20">
                        <!--<div-->
                        <!--class="bor_D9D9D9 br_8 pl10 pr15 pt16 pb44 mr20 relative pointer"-->
                        <!--v-on:click="profitredeemflag = '0'"-->
                        <!--&gt;-->
                        <!--<div class="fs18 c_333 mb10">大成钱柜</div>-->
                        <!--<div class="c_999 fs14">-->
                        <!--最新七日年化收益率:{{-->
                        <!--$util.isEmpty(xjbFundInfo.growthrate)-->
                        <!--? "&#45;&#45;"-->
                        <!--: $util.fmtNum(xjbFundInfo.growthrate, 2)-->
                        <!--}}%。-->
                        <!--</div>-->
                        <!--<div class="c_999 fs14">买基金立享优惠</div>-->
                        <!--<img-->
                        <!--src="../../assets/img/recommend.png"-->
                        <!--class="absolute w65 h65 _t2 _r2"-->
                        <!--/>-->
                        <!--<div-->
                        <!--v-if="profitredeemflag === '0'"-->
                        <!--class="bc_E60012 h30 w100x br-b-7 absolute l0 b0 flex wcenter hcenter"-->
                        <!--&gt;-->
                        <!--<img-->
                        <!--src="../../assets/img/square-checked-white.png"-->
                        <!--class="w16 h12"-->
                        <!--/>-->
                        <!--</div>-->
                        <!--</div>-->
                        <div
                            class="bor_D9D9D9 br_8 pl10 pr15 pt16 pb44 relative pointer"
                            v-on:click="profitredeemflag = '1'"
                        >
                            <div class="fs18 c_333 mb10">银行卡</div>
                            <div class="c_999 fs14">银行活期存款利率：0.35%。</div>
                            <div class="c_999 fs14">若不急需现金，建议转至钱柜</div>
                            <div
                                v-if="profitredeemflag === '1'"
                                class="bc_E60012 h30 w100x br-b-7 absolute l0 b0 flex wcenter hcenter"
                            >
                                <img
                                    src="../../assets/img/square-checked-white.png"
                                    class="w16 h12"
                                />
                            </div>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item
                    v-show="fundInfo.debitcycle == '0' && fundInfo.debitdate >= 29"
                    label="当月日期不足处理："
                    prop="nonexistdayflag"
                    class="form-text"
                >
                    <el-radio-group v-model="fundInfo.nonexistdayflag" :disabled="action === '2'">
                        <el-radio
                            v-for="item in nonexistdayArr"
                            :key="item.subitem"
                            :label="item.subitem"
                            name="nonexistdayflag"
                        >
                            {{ item.subitemname }}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <!--<el-form-item-->
                <!--v-if="-->
                <!--fund.fundcode !== xjbFundInfo.fundcode &&-->
                <!--selectedTab !== '7' &&-->
                <!--fundInfo.way === '2' &&-->
                <!--!$route.query.isCom-->
                <!--"-->
                <!--&gt;-->
                <!--<div class="flex hcenter">-->
                <!--<img-->
                <!--v-if="isagreeeasybuy === '1'"-->
                <!--src="../../assets/img/circle-checked.png"-->
                <!--class="w20 h20 pointer"-->
                <!--v-on:click="isagreeeasybuy = '0'"-->
                <!--/>-->
                <!--<img-->
                <!--v-if="isagreeeasybuy === '0'"-->
                <!--src="../../assets/img/circle-unchecked.png"-->
                <!--class="w20 h20 pointer"-->
                <!--v-on:click="isagreeeasybuy = '1'"-->
                <!--/>-->
                <!--<div class="ml10">省钱购（自动帮您用钱柜买基金，享0折优惠）</div>-->
                <!--<el-tooltip placement="top">-->
                <!--<div slot="content">-->
                <!--省钱购是什么？-->
                <!--<br />-->
                <!--银行卡资金将先充值大成钱柜，后自动帮您买入目标基金-->
                <!--<br />-->
                <!--省钱购有什么好处？-->
                <!--<br />-->
                <!--购买基金费用可低至0折-->
                <!--<br />-->
                <!--什么产品支持省钱购？-->
                <!--<br />-->
                <!--除货币基金外和产品C类份额外，都支持使用省钱购买基金-->
                <!--</div>-->
                <!--<img src="../../assets/img/tip.png" class="w18 h18 ml12" />-->
                <!--</el-tooltip>-->
                <!--</div>-->
                <!--</el-form-item>-->
                <el-form-item
                    v-if="isPwdCheck"
                    label="交易密码："
                    prop="pwd"
                    :class="{ 'form-text': fund.sign }"
                >
                    <el-input
                        v-model.trim="fundInfo.pwd"
                        type="password"
                        placeholder="请输入交易密码"
                        :maxlength="16"
                    />
                    <!--                    <span-->
                    <!--                        class="redemp-btn"-->
                    <!--                        v-on:click.prevent="$router.push({ name: 'tradepwd' })"-->
                    <!--                    >-->
                    <!--                        <span class="like-a">忘记密码？</span>-->
                    <!--                    </span>-->
                </el-form-item>
                <el-form-item style="margin-left: -80px">
                    <div
                        v-if="readFileInfoList.length !== 0"
                        class="check-box bar-pad showChenckbox"
                        style="
                            font-size: 14px;
                            display: flex;
                            align-items: flex-start;
                            padding-left: -10px;
                        "
                    >
                        <ul>
                            <li
                                v-for="(item, index) in readFileInfoList"
                                :key="index"
                                class="flex hcenter"
                            >
                                <!--<a v-if="item.textaddress.startsWith('http')" v-on:click="getClick(index)"-->
                                <!--:href="item.textaddress" style="text-decoration:none; color: red"-->
                                <!--target="_blank">《{{item.textname}}》</a>-->
                                <!--<span v-else   v-on:click="showPdf(item.textaddress)">《{{item.textname}}》</span>-->
                                <!-- v-if="$cache.getCompanyInfoParam().pdf_open_way === '0'" -->
                                <!-- :href="$util.src('/sale-mid-ump/file/cmsDownload', { fileCode: item.fileid,isopenfile:1 }, true)" -->
                                <input v-model="checkbox" type="checkbox" class="w18 h18" />
                                <div>
                                    <span class="ml4 c_999">同意</span>
                                    <a
                                        style="text-decoration: none; color: red; cursor: pointer"
                                        target="_blank"
                                        v-on:click="getClick(index)"
                                    >
                                        《{{ item.filename }}》
                                    </a>
                                </div>
                                <!-- <a v-else :href="item.textaddress" style="text-decoration:none; color: red" target="_blank">《{{item.filename}}》</a> -->
                            </li>
                        </ul>
                    </div>
                </el-form-item>
                <el-form-item>
                    <div style="width: 50%">
                        <el-button class="medium bc_E4E4E4 c_666666" v-on:click="$router.back()">
                            返回重选
                        </el-button>
                        <el-button
                            type="primary"
                            class="medium"
                            :disabled="time > 0 || checkBuy == false || isOpen"
                            v-on:click="doAction"
                        >
                            确定
                        </el-button>
                    </div>
                </el-form-item>
            </el-form>
            <pdf-popup
                base64
                :visible="pdfVisible"
                :need-time="needTime"
                :read-file-info-list="currentFileInfoList"
                v-on:close="finishReading"
            ></pdf-popup>
            <fund-protocol
                v-if="!buySuccess"
                v-model="protocol"
                :fund="fund"
                v-on:all-read="generalBuy"
            />
            <result
                v-if="buySuccess"
                :active="2"
                :result="result"
                v-on:return-page="reset"
                v-on:return-login="$router.push({ name: 'myplan' })"
            />
        </div>
        <footerQuestions
            :common-question="commonQuestion"
            :warning-html="warningHtml"
        ></footerQuestions>
        <el-dialog
            title="温馨提示"
            :visible.sync="tipVisible"
            :close-on-click-modal="false"
            width="50%"
        >
            <div class="bold mb20">
                您当前自定义的目标收益率较低，可能会因为以下原因导致亏损等。
            </div>
            <div class="mb20">(1)部分基金7日内赎回将会收取1.5%赎回费，详情请参阅基金公告</div>
            <div>
                (2)当T日收益率达到预设的目标收益时(QDII基金为T-1日)，在T+1日将自动赎回至大成钱柜，T+1日净值波动与赎回费可能会影响实际的收益。赎回后定投继续进行。
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button v-on:click="tipVisible = false">重新选择</el-button>
                <el-button
                    :loading="isOpen"
                    type="primary"
                    v-on:click="
                        tipVisible = false;
                        getSdxProtocol();
                    "
                >
                    已了解
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import result from "@/components/layout/result";
import fundProtocol from "@/components/form/fundProtocol";
import cache from "@/assets/js/cache";
import PdfPopup from "@/components/util/pdfPopup";
import fundApi from "@/api/fund";
import footerQuestions from "@/components/layout/footerQuestions.vue";

export default {
    name: "PlanBuy",
    components: {
        result,
        fundProtocol,
        PdfPopup,
        footerQuestions
    },
    props: {
        generalFund: {
            // 基金信息基本数据
            required: true,
            type: Object
        },
        setFund: {
            // 智慧定投专属数据
            type: Object,
            default: function () {
                return {};
            }
        },
        wisdom: {
            // 是否是智慧定投
            type: Boolean,
            default: false
        },
        action: {
            // 定投操作类型，0签署定投协议，1修改定投协议，2启用定投协议
            type: String,
            default: "0"
        }
    },
    data() {
        return {
            // 表单信息
            fundInfo: {
                all: "0.00",
                amount: "",
                way: "",
                sharetype: "",
                buyplanname: "",
                debitcycle: "",
                debitdate: "",
                indextype: "000001.SH",
                policyvalue: "25",
                investscale: "0.1",
                pay: "",
                pwd: "",
                nonexistdayflag: ""
                // protocol: ""
            },
            feeGate: {},
            feeH: "", // 费率信息
            isPwdCheck: false, // 是否校验密码
            pla: "请输入起购金额",
            buySuccess: false, // 购买状态
            result: {
                // 结果页面信息
                cla: "register-success",
                msg: "您定投的申请已提交成功！",
                btnMsg: "预计下次扣款日期11月30日，如遇节假日则顺延，请耐心等待",
                special: false,
                btnL: {
                    text: "继续定投",
                    event: "return-page"
                },
                btnR: {
                    text: "我的定投",
                    event: "return-login"
                }
            },
            xjbAll: 0,
            time: 0, // 发送短信倒计时
            fund: {}, // 基金信息获取
            bankLists: [], // 银行卡列表
            limit: { text: "定投金额范围为：", min: "0", max: "0" }, // 限额
            rules: {
                // 校验规则配置
                amount: [
                    { required: true, message: "请输入每期扣款金额", trigger: "blur" },
                    { validator: this.amountLimit, mes: "投资金额", trigger: "blur" }
                ],
                pay: [{ required: true, message: "请选择支付方式", trigger: "change" }],
                selectedBankid_card: [{ validator: this.validateCard, trigger: "change" }],
                buyplanname: [{ validator: this.checkBuyPlanName, trigger: "blur" }],
                debitcycle: [{ required: true, message: "请选择扣款周期", trigger: "change" }],
                debitdate: [{ validator: this.checkDebitdate, trigger: "change" }],
                indextype: [{ required: true, message: "请选择参考指数", trigger: "change" }],
                policyvalue: [{ required: true, message: "请选择均线", trigger: "change" }],
                investscale: [{ required: true, message: "请选择极差", trigger: "change" }],
                pwd: [{ required: true, message: "请输入交易密码", trigger: "blur" }]
            },
            bankInfo: {}, // 校验银行卡信息
            xjbInfo: [],
            cfmdate: "", // 确认日期
            debitcycleArr: [],
            protocol: false,
            debitdateArr: [],
            indexType: [],
            subjectIndex: [],
            investMove: [],
            xjbSel: {}, // 当前选中现金宝信息
            firstinvestdate: "",
            bankId: "", // 已选中网点信息
            checkbox: false, // 阅读确认1
            checkTime: true, // 阅读确认2
            checkBuy: true,
            readFileInfoList: [], // 披露文件信息
            readappno: "", // 申请单编号
            countdown: "",
            interval: "",
            nonexistdayArr: [
                {
                    subitem: "0",
                    subitemname: "当月最后一日"
                },
                {
                    subitem: "1",
                    subitemname: "顺延到下月1号"
                }
            ],
            currentFileInfoList: [], // 当前阅读信批文件
            pdfVisible: false,
            needTime: false,
            hasBankRroute: false, // 是否开启智能路由
            bankListsOfR: [], // 不区分支付渠道的银行卡信息
            selectedBankid_card: "", // 智能路由下选择的银行卡
            hasAccount: false, // 是否有智能路由推荐渠道下的银行卡
            recChannelid: "", // 推荐的channelid
            recChannelname: "", // 推荐的渠道网点名
            timer: "",
            isOpen: false, // 正在发起定投
            clickBtn: null, // 定时器
            isagreeeasybuy: "0",
            commonQuestion: [
                {
                    title: "为什么我绑定的银行卡在新增定投计划时不能使用？",
                    answer: "非常抱歉， 部分银行卡不支持定投功能，故不会在扣款账号中展示。",
                    showFlag: false
                }
            ],
            warningHtml:
                "普通定投计划，又称'定期定额投资'，通过定期投入固定金额的方法，既有利于资金管理，还能够达到积少成多的效果!",
            selectedTab: "1",
            profitredeemflag: "0",
            selectedTargetrate: "0.05",
            inputTargetrate: "",
            oldInputTargetrate: "",
            activeName: "first",
            xjbFundInfo: {}, // 现金宝基金信息
            tipVisible: false
        };
    },
    computed: {
        showTabs() {
            return (
                !this.$route.query.isCom &&
                !this.buySuccess &&
                this.fund.fundcode !== this.xjbFundInfo.fundcode &&
                this.action === "0" &&
                this.$cache.getCompanyInfoParam("10301003") &&
                (this.$cache.getCompanyInfoParam("10301003").indexOf("A86") > -1 ||
                    this.$cache.getCompanyInfoParam("10301003").indexOf("A19") > -1)
            );
        }
    },
    watch: {
        "fundInfo.amount"(val) {
            if (this.hasBankRroute && this.fundInfo.way === "2" && this.action === "0") {
                // 获取智能路由
                this.handleBankRroute();
                return;
            }
            this.isAmount(val);
        },
        "fundInfo.way"(val) {
            this.$refs["fundInfo"].clearValidate();
            this.fundInfo.pay = "";
            if (val === "1") {
                this.bankListsOfR = [];
                this.selectedBankid_card = "";
                if (this.action !== "0") {
                    this.fundInfo.pay = this.bankId;
                    return;
                }
                this.fundInfo.pay = this.xjbInfo[0]
                    ? this.xjbInfo[0].transid + this.xjbInfo[0].xjbfundcode
                    : "";
            } else {
                if (val === "2") {
                    if (this.hasBankRroute) {
                        this.bankListsOfR = this.$util.getBankListsOfR(this.bankLists);
                        this.selectedBankid_card = this.bankListsOfR[1]
                            ? this.bankListsOfR[1].bankid_card
                            : "";
                    }
                } else {
                    this.bankListsOfR = [];
                    this.selectedBankid_card = "";
                }
                this.getBank();
            }
        },
        "fundInfo.pay"(val) {
            if (this.fundInfo.way === "1") {
                const _x = this.xjbInfo.filter((item) => {
                    return item.transid + item.xjbfundcode === val;
                })[0];
                if (_x) {
                    this.xjbSel = _x;
                    this.$set(this.limit, "min", this.fund.xjbmin);
                    this.$set(this.limit, "max", this.fund.xjbmax);
                } else {
                    this.$set(this.limit, "min", "0");
                    this.$set(this.limit, "max", "0");
                }
                this.pla =
                    this.$util.fmtNum(this.limit.min) +
                    "元起，最多可投" +
                    this.$util.fmtNum(this.limit.max) +
                    "元";
                this.queryRate();
            }
        },
        "fundInfo.debitcycle"(val) {
            if (val === "0") {
                let arr = this.$cache.getDict("110207");
                let filterArr = arr.filter(
                    (item, index) =>
                        item.subitem !== "29" && item.subitem !== "30" && item.subitem !== "31"
                );
                this.debitdateArr = filterArr.sort((a, b) => a.itemorder - b.itemorder);
            } else if (val === "1" || val === "2") {
                let arr = this.$cache.getDict("110213");
                this.debitdateArr = arr.sort((a, b) => a.itemorder - b.itemorder);
            }
            let _x = this.debitdateArr.length > 0 ? this.debitdateArr[0].subitem : "";
            if (this.fund.action !== "0" && this.fund.investcycle === val) {
                if (this.$util.isEmpty(this.fund.investcyclevalue)) {
                    // investperiodsvalue
                    this.fund.investcyclevalue = this.fund.investperiodsvalue;
                }
                // _x = this.fund.investcyclevalue;
                if (val === "0") {
                    _x = `0${this.fund.investcyclevalue}`.slice(-2);
                } else {
                    _x = this.fund.investcyclevalue;
                }
            }
            setTimeout(() => {
                this.$set(this.fundInfo, "debitdate", _x);
            }, 10);
        },
        "fundInfo.nonexistdayflag"(val) {
            setTimeout(() => {
                this.$set(this.fundInfo, "nonexistdayflag", val);
            }, 10);
        },

        readFileInfoList: {
            handler: function (obj) {
                if (
                    obj.every(function (item) {
                        return item.read; // 产品概要强制阅读，其他不用
                    })
                ) {
                    this.checkbox = true;
                }
            },
            deep: true
        },
        checkbox(val) {
            if (
                val &&
                !this.isReadFileReading &&
                this.readFileInfoList.length &&
                !this.readFileInfoList[0].read
            ) {
                this.currentFileInfoList = [this.readFileInfoList[0]];
                if (this.currentFileInfoList[0].filetype === "1") {
                    this.needTime = true;
                } else {
                    this.needTime = false;
                }
                this.pdfVisible = true;
            }
            if (!val) {
                this.readFileInfoList.forEach((item) => (item.read = false));
            }
        },
        // 监听基金信息变化
        generalFund() {
            this.setFundInfo();
        },
        // 监听智慧定投信息变化
        setFund: {
            deep: true,
            handler(val) {
                if (this.wisdom && !this.fund.recommend) {
                    this.fund = Object.assign({}, this.fund, val);
                }
            }
        },
        selectedBankid_card(val) {
            //            if(val==="undefined_"){
            //                this.$router.push({ name: 'bank'})
            //                return
            //            }
            if (this.fundInfo.way === "2") {
                this.handleBankRroute();
            }
        },
        // // 动态生成首次扣款日期，暂不使用
        // 'fundInfo.debitdate' (val) {
        //     this.getInvestDate()
        // }
        selectedTargetrate(val) {
            if (val === "") {
                setTimeout(() => {
                    document.getElementById("par3Id").focus();
                }, 500);
            }
        },
        inputTargetrate(val) {
            if (isNaN(val) || val.indexOf(".") > -1 || Number(val) < 0) {
                this.inputTargetrate = this.oldInputTargetrate;
            } else {
                this.oldInputTargetrate = this.inputTargetrate;
            }
        }
    },
    mounted() {
        this.indexType = this.$cache.getDict("110033");
        this.subjectIndex = this.$cache.getDict("110211");
        this.investMove = this.$cache.getDict("110270");
        this.isPwdCheck = this.$cache.getPwdCheck(this.generalFund.way);
        this.debitcycleArr = this.$cache.getDict("110009");
        // 查询现金宝信息
        this.xjbFundInfo = JSON.parse(sessionStorage.getItem("xjbFundInfo"));
        this.setFundInfo();
        this.getFileInfo();
        // 是否开启智能路由
        this.hasBRroute();
    },
    methods: {
        clickTab(val) {
            if (
                val === "7" &&
                (this.$util.isEmpty(this.fund.businessflag) ||
                    this.fund.businessflag.indexOf("08") === -1)
            ) {
                this.$message.warning("该基金不支持目标盈定投");
                return;
            }
            if (
                val === "4" &&
                (this.$util.isEmpty(this.fund.businessflag) ||
                    this.fund.businessflag.indexOf("06") === -1)
            ) {
                this.$message.warning("该基金不支持智能定投");
                return;
            }
            this.selectedTab = val;
        },
        // 是否开启智能路由
        hasBRroute(val) {
            this.hasBankRroute = sessionStorage.getItem("hasBankRroute", "0") != "0";
        },
        // 获取智能路由
        handleBankRroute() {
            let _this = this;
            if (this.timer) {
                clearTimeout(this.timer);
            }
            this.timer = setTimeout(function () {
                let data = {
                    banknameid: _this.selectedBankid_card.split("_")[0], // 银行编号
                    fundtype: _this.fund.fundtype === "2" ? "2" : "1", // 基金类型
                    applicationamount: _this.fundInfo.amount // 申请金额
                };
                _this.$util.request("/acct/bank/route", data).then((res) => {
                    // 获取选择的银行卡下的数据
                    function getData() {
                        let arr = [];
                        _this.bankLists.forEach((item) => {
                            item.options.forEach((item1) => {
                                if (
                                    item1.bankcode === _this.selectedBankid_card.split("_")[0] &&
                                    item1.label.indexOf(_this.selectedBankid_card.split("_")[1]) >
                                        -1
                                ) {
                                    arr[arr.length] = item1;
                                }
                            });
                        });
                        return arr[0] || [];
                    }
                    let recBankInfo = {};
                    _this.hasAccount = false;
                    if (res.data && res.data[0]) {
                        _this.recChannelid = res.data[0].channelid;
                        recBankInfo = _this.getBankInfo(_this.recChannelid);
                        if (recBankInfo.label && !_this.$util.isEmpty(recBankInfo.label)) {
                            // 推荐的渠道网点下有存在的银行卡
                            if (
                                recBankInfo.label.indexOf(_this.selectedBankid_card.split("_")[1]) >
                                -1
                            ) {
                                _this.hasAccount = true;
                                // 推荐的渠道网点下存在的银行卡，正好为当下选择的银行卡
                                _this.bankInfo = recBankInfo;
                                _this.fundInfo.pay = recBankInfo.bankcardid;
                            } else {
                                // 推荐的渠道网点下存在的银行卡，不是当下选择的银行卡
                                _this.bankInfo = getData();
                                _this.fundInfo.pay = _this.bankInfo.bankcardid;
                            }
                        }
                        if (!_this.hasAccount) {
                            // 推荐的渠道网点下无存在的银行卡
                            _this.bankInfo = getData();
                            _this.fundInfo.pay = _this.bankInfo.bankcardid;
                        }
                        // 获取费率
                        _this.queryRate();
                    } else {
                        _this.bankInfo = getData();
                        _this.fundInfo.pay = _this.bankInfo.bankcardid;
                        // 获取费率
                        _this.queryRate();
                    }
                });
            }, 500);
        },
        getBankInfo(channelid) {
            let bankInfo = {};
            for (const group of this.bankLists) {
                if (group.options && group.options.length > 0) {
                    for (const bank of group.options) {
                        if (bank.value === channelid) {
                            bankInfo = bank;
                            break;
                        }
                    }
                }
            }
            return bankInfo;
        },
        // 获取披露文件信息
        getFileInfo() {
            let fundcode = "";
            if (this.$route.query.isCom) {
                this.fund.subfundinfos &&
                    this.fund.subfundinfos.forEach((item, index) => {
                        fundcode +=
                            item.fundcode +
                            (index === this.fund.subfundinfos.length - 1 ? "" : ",");
                    });
            } else {
                fundcode = this.fund.fundcode;
            }
            this.$util.queryReadFileInfo(
                {
                    fundcode: fundcode,
                    filetype: ""
                },
                (res) => {
                    this.readFileInfoList = res;
                    //                this.readFileInfoList=this.readFileInfoList.concat(this.readFileInfoList) // 临时代码
                    // res.forEach(item => {
                    //     item.read = false;
                    //     if(item.filetype.trim() === '1'){//产品概要
                    //         this.readFileInfoList.unshift(item);
                    //     }else{
                    //         this.readFileInfoList.push(item);
                    //     }
                    // })
                }
            );
        },
        validateCard(rule, value, callback) {
            if (!this.selectedBankid_card) {
                callback(new Error("请选择支付方式"));
            } else {
                callback();
            }
        },
        checkBuyPlanName(rule, value, callback) {
            // 定投恢复计划名称不校验必填（有的存量数据没有值）
            if (this.action !== "2") {
                if (value.trim() === "") {
                    callback(new Error("请输入计划名称"));
                    return;
                }
                this.$util.validateCCharacter(rule, value, callback);
            } else {
                callback();
            }
        },
        checkDebitdate(rule, value, callback) {
            if (value.trim() === "" && value.trim() !== "5") {
                callback(new Error("请选择扣款日期"));
            } else {
                callback();
            }
        },
        // 获取链接点击事件
        getClick(index) {
            this.currentFileInfoList = [this.readFileInfoList[index]];
            this.readFileInfoList[index].read = true;
            if (this.currentFileInfoList[0].filetype === "1") {
                this.needTime = true;
            } else {
                this.needTime = false;
            }
            this.pdfVisible = true;
        },
        finishReading() {
            this.pdfVisible = false;
            if (this.currentFileInfoList[0].filetype === "1") {
                this.isReadFileReading = true;
            }
        },
        // 再次购买重置表单
        reset() {
            // 控制父组件是否显示基金列表
            if (this.wisdom) {
                this.$emit("back-fn", true);
            }
            this.buySuccess = false;
            this.bankInfo = {};
            this.$set(this.fundInfo, "way", "");
            this.$set(this.fundInfo, "amount", "");
            this.$set(this.fundInfo, "buyplanname", "");
            this.$set(this.fundInfo, "pwd", "");
            this.getBuyWay();
        },
        validateCCharacter(rule, value, callback) {
            if (value !== "") {
                return this.$util.validateCCharacter(rule, value, callback);
            } else {
                callback();
            }
        },
        // 切换为银行卡支付时数据初始化
        getBank() {
            // 获取银行卡信息
            let _x = this.bankLists[0] ? this.bankLists[0].options[1].bankcardid : "";
            if (this.action !== "0") {
                _x = this.bankId;
            }
            if (_x) {
                this.$set(this.fundInfo, "pay", _x);
                this.bankSel(_x);
            }
        },
        // 处理限额
        amountLimit(rule, value, callback) {
            this.$util.validateAmountLimit(this, rule, value, callback);
        },
        // 处理金额
        isAmount(val) {
            const _val = this.$util.checkAmount(val);
            clearTimeout(this.query);
            this.query = setTimeout(() => {
                this.$set(this.fundInfo, "amount", _val);
                this.queryRate();
            }, 1);
        },
        // 费率入参获取
        queryRate() {
            const _this = this;
            let _d = null;
            if (
                this.fundInfo.amount > 0 &&
                this.fundInfo.sharetype === "A" &&
                ((this.bankInfo.value && this.fundInfo.way !== "1") ||
                    (this.xjbSel.xjbfundcode && this.fundInfo.way === "1")) &&
                this.fund.fundtype !== "2"
            ) {
                _d = {
                    fundcode:
                        this.fundInfo.way === "1" ? this.xjbSel.xjbfundcode : this.fund.fundcode,
                    sharetype: this.fund.sharetype,
                    applicationamount: this.fundInfo.amount,
                    applicationvol: "0",
                    paymode: this.fundInfo.way,
                    businesscode: "59",
                    channelid:
                        this.fundInfo.way === "1" ? this.xjbSel.channelid : this.bankInfo.value
                };
                if (this.fund.comrate) {
                    _d.comratelist = this.fund.comrate;
                }
            }
            this.$util.getFee(_d, (res) => {
                _this.feeGate = res;
                _this.feeH = _this.$util.fmtNum(_this.feeGate.estimatedcost);
            });
        },
        // 对频繁点击按钮做处理
        doAction() {
            const _this = this;
            clearTimeout(this.clickBtn);
            this.clickBtn = setTimeout(function () {
                _this.recAddBank();
            }, 500);
        },
        // 检查是否需要提示新增最优惠渠道卡
        recAddBank() {
            if (this.isOpen) {
                return;
            }
            const _this = this;
            let contentText = "";
            _this.$refs["fundInfo"].validate((valid) => {
                if (valid) {
                    if (_this.fundInfo.way !== "2" || !_this.hasBankRroute) {
                        _this.submitInfo("fundInfo");
                        return;
                    }
                    if (!_this.hasAccount) {
                        _this.$util.getBankInfo({ biztype2: "add" }, (res) => {
                            if (res && res.length > 0 && !_this.$util.isEmpty(_this.recChannelid)) {
                                let canAdd = false; // 是否可以新增推荐渠道下的银行卡
                                for (let i = 0; i < res.length; i++) {
                                    if (_this.recChannelid === res[i].channelid) {
                                        canAdd = true;
                                        _this.recChannelname =
                                            _this.$cache
                                                .getDict("110079", res[i].paycenterid)
                                                .toString()
                                                .substr(0, 4) +
                                            "-" +
                                            _this.$cache.getDict("110080", res[i].bankcode);
                                        contentText =
                                            "使用" +
                                            _this.recChannelname +
                                            "支付更优惠，请添加" +
                                            _this.recChannelname +
                                            "的银行卡";
                                        _this.$util.showMessageBox(
                                            _this,
                                            "温馨提示",
                                            contentText,
                                            "前往增卡",
                                            "继续交易",
                                            function () {
                                                delete res[i].child;
                                                sessionStorage.setItem(
                                                    "recBankInfo",
                                                    JSON.stringify(res[i])
                                                );
                                                _this.$router.push({ name: "addbank" });
                                            },
                                            function () {
                                                _this.submitInfo("fundInfo");
                                            }
                                        );
                                        return;
                                    }
                                }
                                if (!canAdd) {
                                    _this.submitInfo("fundInfo");
                                }
                            } else {
                                _this.submitInfo("fundInfo");
                            }
                        });
                    } else {
                        _this.submitInfo("fundInfo");
                    }
                } else {
                    this.$errorScroll();
                }
            });
        },
        /* 提交表单数据，校验用户信息 */
        submitInfo(formName) {
            if (this.readFileInfoList.length !== 0) {
                if (!this.checkbox) {
                    return this.$alert(
                        "根据相关法规要求，请在交易前仔细阅读相关文件，并勾选“我已阅读并同意”选项。",
                        "提示",
                        { confirmButtonText: "确定" }
                    );
                }
            }
            // 获取留痕申请编号
            this.$util.writeFileInfo(
                {
                    readFileInfoList: this.readFileInfoList,
                    fundcode: this.fund.fundcode,
                    tano: this.fund.tano
                },
                (res) => {
                    this.readappno = res;
                }
            );

            const _this = this;
            _this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (_this.action === "1") {
                        let _change = false;
                        try {
                            Object.keys(_this.fundInfo).forEach((key) => {
                                if (_this.fundInfo[key] !== _this.initVal[key] && key !== "pay") {
                                    if (
                                        (key === "amount" &&
                                            Number(_this.fundInfo[key]) !==
                                                Number(_this.initVal[key])) ||
                                        key !== "amount"
                                    ) {
                                        _change = true;
                                        throw new Error("EndIterative");
                                    }
                                }
                            });
                        } catch (e) {
                            if (e.message != "EndIterative") throw e;
                        }
                        if (!_change) {
                            _this
                                .$alert("您未修改任何定投信息，无需提交", "信息未变动提示", "", {
                                    confirmButtonText: "确定",
                                    type: "warning",
                                    callback: (action) => {}
                                })
                                .then(() => {
                                    return false;
                                })
                                .catch(() => {
                                    return false;
                                });
                            return;
                        }
                    }
                    if (!_this.selectedTargetrate && Number(_this.inputTargetrate) < 4) {
                        this.tipVisible = true;
                        return;
                    }
                    this.getSdxProtocol();
                } else {
                    this.$errorScroll();
                }
            });
        },
        // 获取产品适当性匹配信息
        getSdxProtocol() {
            this.$util.getSdxProtocol(this.fund, (res) => {
                this.fund = res;
                this.protocol = true;
            });
        },
        generalBuy(val) {
            this.protocol = false;
            if (!val) return;
            const _this = this;
            if (_this.readFileInfoList.length > 0 && _this.readappno.length === 0) {
                return this.$alert("没有留痕申请编号,操作失败 请联系客服");
            }
            const _x = _this.getInvest();
            // 组合定投
            if (this.$route.query.isCom) {
                this.combInvestPlanManager(_x);
                return;
            }
            let _xjbSel = {};
            // 获取现金宝信息
            if (this.fundInfo.way === "1") {
                _xjbSel = this.xjbInfo.filter((item) => {
                    return item.transid + item.xjbfundcode === _this.fundInfo.pay;
                })[0];
                // 现金宝不存在，返回
                if (!_xjbSel) {
                    return;
                }
            }
            let data = {
                investcycle: "",
                investcyclevalue: "",
                investperiods: _this.fundInfo.debitcycle,
                investperiodsvalue: _x.investcyclevalue,
                riskwarnflag: _this.fund.riskwarnflag,
                riskmismatchflag: _this.fund.riskmismatchflag,
                highriskwarnflag: _this.fund.highriskwarnflag,
                fundmismatchflag: _this.fund.fundmismatchflag,
                channelid: _this.fundInfo.way === "2" ? _this.bankInfo.value : _xjbSel.channelid,
                tradepassword: _this.$util.enc(_this.fundInfo.pwd),
                planname: _this.fundInfo.buyplanname,
                continueinvestamount: _this.fundInfo.amount,
                firstsaledate: "",
                firstinvestdate: "",
                contractno: _this.readappno,
                nonexistdayflag: _this.fundInfo.nonexistdayflag || "",
                transactionaccountid: _this.bankInfo.transactionaccountid,
                fundcode: _this.fund.fundcode,
                planflag: _this.selectedTab
            };
            // 现金宝定投
            if (_this.fundInfo.way === "1") {
                data.targetfundcode = _this.xjbFundInfo.fundcode;
                data.saveplanmode = "2";
                data.branchcode = _xjbSel.branchcode;
                data.fundcode = _xjbSel.xjbfundcode;
                data.xjbfundcode = _xjbSel.xjbfundcode;
                data.sellvalue = _this.fundInfo.amount;
                data.bankcardid = _xjbSel.bankcardid;
                data.transid = _xjbSel.transid;
                data.targetsharetype = _this.fundInfo.sharetype;
                data.sharetype = _xjbSel.sharetype;
                data.tano = _xjbSel.tano;
            } else {
                // 银行卡定投
                if (_this.isagreeeasybuy === "1") {
                    // 省钱购
                    data.saveplanmode = "3";
                    data.targetfundcode = _this.xjbFundInfo.fundcode;
                }
                if (_this.fund.fundcode === _this.xjbFundInfo.fundcode) {
                    data.saveplanmode = "0";
                }
                // data.tano = _this.fund.tano;
                data.bankcode = _this.bankInfo.bankcode;
                data.channelid = _this.bankInfo.value;
                data.paycenterid = _this.bankInfo.paycenterid;
                // data.sharetype = _this.fundInfo.sharetype;
            }
            // 修改定投协议处理
            if (_this.action === "1") {
                data.planno = _this.fund.planno;
                data.transactionaccountid = _this.fund.transactionaccountid;
            }
            //  重新启用定投协议处理
            if (_this.action === "2") {
                _this.planResume({
                    planno: _this.fund.planno,
                    transactionaccountid: _this.fund.transactionaccountid,
                    action: "resume",
                    tradepassword: data.tradepassword
                });
                return;
            }
            // 止盈定投
            if (this.selectedTab === "7") {
                data.policytype = "c";
                data.planflag = "7";
                data.largeredemptionflag = "0";
                if (this.selectedTargetrate) {
                    data.targetrate = this.selectedTargetrate;
                } else {
                    data.targetrate = Number(this.inputTargetrate) / 100 + "";
                }
                data.profitredeemflag = this.profitredeemflag;
                if (this.profitredeemflag === "0") {
                    data.profittobuyfundcode = this.xjbFundInfo.fundcode;
                }
            }
            // 智能定投
            if (this.selectedTab === "4") {
                data.planflag = "4";
                data.policytype = "a";
                data.indextype = _this.fundInfo.indextype;
                data.policyvalue = _this.fundInfo.policyvalue;
                data.investscale = _this.fundInfo.investscale;
                data.formula = "c";
            }
            // 下单
            _this.planOpen(data);
        },

        // 组合定投下单（新增，修改，启用）准备
        combInvestPlanManager(_x) {
            const info = this.$cache.getUser();
            let data = {
                custno: info.custno,
                transactionaccountid: this.bankInfo.transactionaccountid,
                tradepassword: this.$util.enc(this.fundInfo.pwd),
                status: this.action === "0" ? "1" : "2",
                planno: this.action === "0" ? "" : "",
                planperiods: this.fundInfo.debitcycle,
                planperiodsvalue: _x.investcyclevalue,
                portfoliocode: this.fund.portfoliocode,
                buyamount: this.fundInfo.amount,
                paychannel: this.fund.paychannel,
                saveplanflag: "a",
                riskwarnflag: this.fund.riskwarnflag,
                riskmismatchflag: this.fund.riskmismatchflag,
                highriskwarnflag: this.fund.highriskwarnflag,
                fundmismatchflag: this.fund.fundmismatchflag
            };
            // 下单
            this.planOpen(data);
        },

        async planResume(params) {
            const res = await fundApi.planOperation(params);
            // 获取下单时间
            this.cfmdate = res.data ? res.data.nextplandate || "" : "";
            this.resultMes(res);
        },

        async planOpen(params) {
            this.isOpen = true;
            setTimeout(() => {
                this.isOpen = false;
            }, 3000);
            const res = await fundApi[
                this.$route.query.isCom ? "combInvestPlanManager" : "planOpen"
            ](params);
            // 获取下单时间
            this.cfmdate = res.data ? res.data.firstinvestdate || "" : "";
            this.resultMes(res);
        },

        // 初始化扣款周期和扣款日期值
        getInvest() {
            let _x = {
                investperiods: "",
                investperiodsvalue: "",
                investcyclevalue: ""
            };
            const selVal = this.fundInfo.debitdate;
            if (this.fundInfo.debitcycle === "0") {
                _x.investperiods = "0";
                _x.investperiodsvalue = "1";
                _x.investcyclevalue = selVal;
            } else if (this.fundInfo.debitcycle === "1") {
                _x.investperiods = "1";
                _x.investperiodsvalue = "1";
                _x.investcyclevalue = selVal;
            } else if (this.fundInfo.debitcycle === "2") {
                _x.investperiods = "1";
                _x.investperiodsvalue = "2";
                _x.investcyclevalue = selVal;
            } else if (this.fundInfo.debitcycle === "5") {
                _x.investperiods = "2";
                _x.investperiodsvalue = "1";
                _x.investcyclevalue = "1";
            } else {
                _x.investperiods = "";
                _x.investperiodsvalue = "";
                _x.investperiodsvaluedesc = "";
            }
            return _x;
        },
        // 获取第一次扣款日期，暂未使用
        getInvestDate() {
            const _x = this.getInvest();
            const _data = {
                fundcode: this.fund.fundcode,
                tano: this.fund.tano,
                investperiods: _x.investperiods,
                investperiodsvalue: _x.investperiodsvalue,
                investcycle: this.fundInfo.debitcycle,
                investcyclevalue: _x.investcyclevalue
            };
            this.$util.request("trade/plan/firstinvestdate", _data).then((res) => {
                if (res.data) {
                    this.firstinvestdate = res.data[0].firstinvestdate;
                }
            });
        },
        // 获取对应银行卡信息
        bankSel(val) {
            const _this = this;
            for (const group of this.bankLists) {
                if (group.options && group.options.length > 0) {
                    for (const bank of group.options) {
                        if (bank.bankcardid === val) {
                            _this.bankInfo = bank;
                            break;
                        }
                    }
                }
            }
            this.$set(this.limit, "min", this.bankInfo.netnominbuy);
            this.$set(this.limit, "max", this.bankInfo.netnomaxbuy);
            this.pla =
                this.$util.fmtNum(this.bankInfo.netnominbuy) +
                "元起，最多可投" +
                this.$util.fmtNum(this.bankInfo.netnomaxbuy) +
                "元";
            if (this.hasBankRroute && this.fundInfo.way === "2" && this.action === "0") {
                // 获取智能路由
                this.handleBankRroute();
                return;
            }
            this.queryRate();
        },
        // 定投前信息查询
        async getBuyWay() {
            const _this = this;
            // 初始化扣款周期
            let _debit = this.debitcycleArr[0].subitem;
            let _nonexistday = this.nonexistdayArr[0].subitem;
            if (this.action !== "0") {
                if (this.$util.isEmpty(this.fund.investcycle)) {
                    this.fund.investcycle = this.fund.investperiods;
                }
                _debit = this.fund.investcycle;
                _nonexistday = this.fund.nonexistdayflag;
                this.selectedTab = this.fund.planflag;
                if (this.fund.planflag === "7") {
                    if (
                        Number(this.fund.targetrate) == 0.05 ||
                        Number(this.fund.targetrate) == 0.08 ||
                        Number(this.fund.targetrate) == 0.1
                    ) {
                        this.selectedTargetrate = this.fund.targetrate;
                    } else {
                        this.selectedTargetrate = "";
                        this.inputTargetrate = this.fund.targetrate && this.fund.targetrate * 100;
                    }
                    this.profitredeemflag = this.fund.profitredeemflag || "0";
                }
            }
            this.$set(this.fundInfo, "debitcycle", _debit);
            this.$set(this.fundInfo, "nonexistdayflag", _nonexistday);
            let _param = { fundcode: "", portfoliocode: "", sharetype: this.fund.sharetype };
            if (this.$route.query.isCom) {
                _param.portfoliocode = this.fund.portfoliocode;
            } else {
                _param.fundcode = this.fund.fundcode;
            }
            //            _param.fundcode="004040"// 临时代码
            if (this.fund.comrate) {
                _param.combinationflag = this.fund.combinationflag ? this.fund.combinationflag : "";
                _param.combinationrate = this.fund.comrate;
            }
            const res = await fundApi.tradePlan(_param);
            //            res.data.returnList2 =
            //                res.data.returnList2 &&
            //                res.data.returnList2.filter((item) => item.modilimit !== "1"); // 临时注释
            res.data.returnList3 =
                res.data.returnList3 &&
                res.data.returnList3.filter((item) => item.isopenplaninfo === "1"); // 临时注释
            if (res.data) {
                this.fund = Object.assign(this.fund, res.data.returnList1);
                this.xjbInfo = res.data.returnList2;
                let _all = 0;
                this.xjbInfo.forEach((item) => {
                    _all += Number(item.xjbasset);
                });
                this.xjbAll = _all;
                let _way = this.fund.xjbflag == "1" ? "1" : "2";
                if (this.fund.payflag != "1" && this.fund.hkflag == "1") {
                    _way = "3";
                }
                if (_this.action !== "0") {
                    _way = _this.fund.planpaytype == "2" ? "1" : "2";
                    _this.beforePlan(res.data.returnList3);
                }
                _this.$set(_this.fund, "way", _way);
                _this.$set(_this.fundInfo, "way", _way);
                if (_this.fund.sharetype) {
                    _this.$set(_this.fundInfo, "sharetype", _this.fund.sharetype.substr(0, 1));
                }
                if (_this.fundInfo.sharetype === "0" || _this.fundInfo.sharetype === "1") {
                    let dict = [{ 0: "A", 1: "B" }];
                    _this.$set(_this.fundInfo, "sharetype", dict[_this.fundInfo.sharetype]);
                }
                _this.bankLists =
                    res.data.returnList3.length > 0
                        ? _this.$util.getBankArr(res.data.returnList3)
                        : [];
                if (_this.action === "1") {
                    _this.initVal = Object.assign({}, _this.fundInfo, {
                        debitdate: _this.fund.investcyclevalue
                    });
                }
            }
            // });
        },
        // 定投前信息获取
        beforePlan(data) {
            const _this = this;
            if (this.fund.planpaytype === "2") {
                data = this.xjbInfo;
            }
            const _bank = data.filter((item) => {
                return (
                    item.channelid === _this.fund.channelid &&
                    item.paycenterid === _this.fund.paychannel
                );
            })[0];
            if (_bank) {
                this.bankId =
                    this.fund.planpaytype == "2"
                        ? _bank.transid + _bank.xjbfundcode
                        : _bank.bankcardid;
            } else {
                _this
                    .$alert(
                        "签署当前定投协议的网点已删除或失效，无法进行下一步操作，点击确认返回首页",
                        "网点信息提示",
                        {
                            confirmButtonText: "确定",
                            type: "warning",
                            callback: (action) => {
                                _this.$router.push("/home");
                            }
                        }
                    )
                    .then(() => {
                        return false;
                    })
                    .catch(() => {
                        return false;
                    });
            }
            // 初始化存在定投协议数据
            this.$set(this.fundInfo, "amount", this.fund.firstinvestamount);
            this.$set(this.fundInfo, "buyplanname", this.fund.buyplanname);
        },
        // 生成确认信息
        resultMes(res) {
            if (res.data) {
                this.result.cla = "register-success";
                this.result.btnMsg =
                    "预计" +
                    (this.action === "1" || this.action === "2" ? "下一" : "首次") +
                    "扣款日期为" +
                    this.$util.fmtDate(this.cfmdate) +
                    "， 如遇节假日则顺延，请耐心等待";
            } else {
                this.result.cla = "register-fail";
                this.result.btnMsg = "原因：" + res.msg;
            }
            if (this.action === "1") {
                this.result.msg =
                    "您的" +
                    (this.fundInfo.way === "1" ? "现金宝" : "") +
                    "定投修改申请已受理" +
                    (this.result.cla === "register-fail" ? "失败" : "成功");
            } else if (this.action === "2") {
                this.result.msg =
                    "您的" +
                    (this.fundInfo.way === "1" ? "现金宝" : "") +
                    "定投启用申请已受理" +
                    (this.result.cla === "register-fail" ? "失败" : "成功");
            } else {
                this.result.msg =
                    "您的" +
                    (this.fundInfo.way === "1" ? "现金宝" : "") +
                    "定投申请已受理" +
                    (this.result.cla === "register-fail" ? "失败" : "成功");
            }

            // 控制父组件是否显示基金列表
            if (this.wisdom) {
                this.$emit("back-fn", false);
            }
            if (this.action !== "0") {
                this.result.btnL = {};
            }
            this.buySuccess = true;
        },
        setFundInfo() {
            this.fund = Object.assign({}, this.generalFund);
            // 定投改变定投金额为空字符串
            this.fundInfo.amount = "";
            this.fundInfo.way = "";
            // 智慧定投不是推荐基金合并极差等值
            if (this.wisdom && !this.fund.recommend) {
                this.fund = Object.assign({}, this.fund, this.setFund);
            }
            this.getBuyWay();
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.el-select-img {
    width: auto !important;
}
.bank-img-sel {
    width: 400px !important;
    box-sizing: border-box;
}
.comp-plan-buy {
    padding-bottom: 30px;
}
.common-question-contain {
    margin-top: 41px;
    padding: 0 20px;
}
:deep(.el-form-item__label) {
    font-size: 14px !important;
}
:deep(.el-tabs__nav-scroll) {
    padding-left: 13px;
}
.tabForm {
    :deep(.el-form-item__label) {
        width: 160px !important;
        color: #333333 !important;
    }
    :deep(.el-form-item__content) {
        margin-left: 160px !important;
    }
}
:deep(.el-tabs__item) {
    font-size: 16px;
}
</style>
